// src/components/UserDetailsDialog.js

import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import axiosInstance from '../utils/axios';
import UserForm from './UserForm';

const UserDetailsDialog = ({ inputEntity, open, onClose, onSubmit, isDisabled = false, showOrganization = true, showUsername=true, showUserType=true  }) => {
    const [entity, setEntity] = useState(inputEntity || {});
    const [error, setError] = useState(null);

    useEffect(() => {
        console.dir("input entity:")
        console.dir(inputEntity)
        if (inputEntity != null) {
            setEntity(inputEntity);
        }
    }, [inputEntity]);


    const handleInputChange = (updatedEntity) => {
        setEntity(updatedEntity);  // Sync form changes with dialog state
    };

    const handleCreateUpdate = async (e) => {
        e.preventDefault();
        try {
            // Some extra changes to make it work
            if (entity["profile"] == null) {
                entity["profile"] = {}
            }
            if ((entity["username"] === null) || (entity["username"] == "")) {
                    entity["username"] = entity["email"]
            }
            // Some extra changes to make it work
            entity["profile"]["type"] = entity["type"];
            entity["profile"]["organization"] = entity["organization_id"]
            delete entity["profile"]["organization_id"] // keep it clean
            delete entity["profile"]["organization_name"] // keep it clean
            //  TODO -- organization name?

            console.dir("handleCreateUpdate entity...");
            console.dir(entity);

            if (entity.id != null) {
                let response = await axiosInstance.put(`users/${entity.id}/`, entity);
                return response.data
            } else {
                let response = await axiosInstance.post('users/', entity);
                return response.data
            }
        } catch (error) {
            console.dir(error)
            setError('Error saving user');
        }
    };

    const handleSave = async (e) => {
        let updatedUser = await handleCreateUpdate(e);
        onSubmit(e, updatedUser);  // Pass the event back to parent component
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg"
            sx={{
                '& .MuiDialog-paper': {
                    minWidth: '800px',
                    maxWidth: '800px',
                },
                display: { open }
            }}
        >
            <DialogTitle>Configure User</DialogTitle>
            <DialogContent>
                {error && <div className="error-message">{error}</div>}
                <UserForm inputEntity={entity} onChange={handleInputChange} showOrganization={showOrganization} showUserType={showUserType} showUsername={showUsername} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UserDetailsDialog;
